import React, { useRef, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

const Hero = ({ backgroundImage }) => {
  const sectionRef = useRef(null);
  const [offsetY, setOffsetY] = useState(0);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.5 });

  const handleScroll = () => setOffsetY(window.pageYOffset);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    const resizeHandler = () => setIsLargeScreen(window.innerWidth >= 1024);
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="hero flex flex-col justify-center items-center relative text-white text-center"
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
        backgroundSize: `${100 + offsetY / 10}% ${100 + offsetY / 10}%`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        filter: "grayscale(50%)",
        paddingLeft: "16px",
        paddingRight: "16px",
        overflowX: "hidden",
        minHeight: "25vh",
      }}
    >
      <div
        className="absolute inset-0"
        style={{ backgroundColor: "rgba(0,0,0,0.1)" }}
      />
      <div className="relative z-10 p-6" ref={ref}></div>
    </section>
  );
};

export default Hero;
